import { Alert, Loader, Modal, TextInput } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faEnvelope, faFilePdf, faPrint, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../../components/Button';
import { noSelectionTextInputProps } from '../receipt/receipt-input.utils';
import { useAttendanceQrController, type AttendanceQrControllerProps } from './useAttendanceQrController';
import settings from './shared/settings-shared.module.scss';
import classes from './attendance-qr.module.scss';

export function AttendanceQrModal(props: AttendanceQrControllerProps & { onClose: () => void }) {
  const state = useAttendanceQrController(props);
  const disabled = !!state.busy;
  return <Modal opened={props.opened} onClose={props.onClose} title="QR לנוכחות" centered dir="rtl" size="lg">
    <div className={settings.section}>
      {state.busy === 'load' && <Loader aria-label="טוען QR לנוכחות" />}
      {state.error && <Alert color="red">{state.error}{!state.qr && <Button variant="icon" onClick={state.retry} disabled={disabled} ariaLabel="נסה שוב"><FontAwesomeIcon icon={faRotateRight as IconProp} /></Button>}</Alert>}
      {state.notice && <Alert color="green">{state.notice}</Alert>}
      {state.qr && <>
        <img className={classes.qr} src={state.qr.qrDataUrl} alt="QR לנוכחות" />
        <a href={state.qr.url} target="_blank" rel="noopener noreferrer">פתיחת נוכחות</a>
        <div className={settings.formActions}>
          <Button variant="icon" className="btn-bordered" onClick={state.print} disabled={disabled}><FontAwesomeIcon icon={faPrint as IconProp} />הדפסה</Button>
          <Button variant="icon" className="btn-bordered" onClick={state.png} disabled={disabled}><FontAwesomeIcon icon={faDownload as IconProp} />PNG</Button>
          <Button variant="icon" className="btn-bordered" onClick={state.pdf} disabled={disabled} loading={state.busy === 'pdf'}><FontAwesomeIcon icon={faFilePdf as IconProp} />PDF</Button>
        </div>
        <TextInput {...noSelectionTextInputProps} classNames={{ input: classes.noSelection }} label="כתובת מייל לקבלת QR" inputMode="email" autoComplete="email" maxLength={254}
          value={state.recipient} onChange={(event) => state.setRecipient(event.currentTarget.value)} disabled={disabled} />
        <Button variant="confirm" onClick={state.email} disabled={disabled} loading={state.busy === 'email'}><FontAwesomeIcon icon={faEnvelope as IconProp} />שליחה במייל</Button>
      </>}
    </div>
  </Modal>;
}